module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "figure"
    }
  }, [_c('figure', {
    staticClass: "imagem"
  }, [_c('a', {
    attrs: {
      "href": _vm.imagem
    }
  }, [_c('img', {
    staticClass: "my-album",
    attrs: {
      "src": _vm.imagem
    }
  })]), _c('figcaption', [_c('small', {
    domProps: {
      "innerHTML": _vm._s(_vm.legenda)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1651e826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/ImagemCover.vue
// module id = 458
// module chunks = 0